





















import { Component, Prop, Mixins } from 'vue-property-decorator'

import AppRouterLink from '@/components/AppRouterLink.vue'
import AppUrlLink from '@/components/AppUrlLink.vue'
import { Common } from '@/mixins'

@Component({
  components: {
    AppRouterLink,
    AppUrlLink
  }
})
export default class extends Mixins(Common) {
  @Prop(Object) readonly banner!: { id: string; link?: string }

  visibilityChanged (isVisible: boolean) {
    if (isVisible) {
      this.$emit('visible', this.banner.id)
    }
  }

  get rootComponent () {
    return Number(this.banner.id) < 0 ? 'div'
      : this.banner.link ? 'AppUrlLink' : 'AppRouterLink'
  }
}
